var $5d0b9dadf46ca8c0$exports = {};
$5d0b9dadf46ca8c0$exports = {
    "endTime": `Zavr\u{161}no vreme`,
    "startTime": `Po\u{10D}etno vreme`,
    "time": `Vreme`
};


export {$5d0b9dadf46ca8c0$exports as default};
//# sourceMappingURL=sr-SP.mjs.map
